import React from "react";
import { Link } from "react-router-dom";
import { SCROLL_TO_PRICING_STATE } from "../../../../utils/scrollToPricing";
import { withRouter } from "../../../../hooks/withRouter";
import { updateUserSettings } from "../../../../api";
import "./UserMenu.scss";

class UserActions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      theme: "light",
    };

    this.toggleUserActions = this.toggleUserActions.bind(this);
    this.closeDropdown = this.closeDropdown.bind(this);
    this.wrapperRef = React.createRef();
  }

  handleOutsideClick = (e) => {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(e.target)) {
      this.setState({ visible: false });
    }
  };

  componentDidMount = () => {
    document.addEventListener("mousedown", this.handleOutsideClick);
    let theme = localStorage.getItem("theme");
    if (theme === null) {
      if (localStorage.getItem("user") !== null) {
        let user = JSON.parse(localStorage.getItem("user"));
        this.setState(
          {
            theme: user.settings && user.settings.darkUIMode ? "dark" : "light",
          },
          () => {
            document.documentElement.setAttribute(
              "data-theme",
              this.state.theme
            );
          }
        );
      }
    } else {
      document.documentElement.setAttribute("data-theme", theme);
      this.setState({
        theme: theme,
      });
    }
  };

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
  }

  closeDropdown() {
    this.setState({ visible: false });
  }

  switchTheme = () => {
    const setTo = this.state.theme === "light" ? "dark" : "light";
    this.setState(
      {
        theme: setTo,
      },
      () => {
        updateUserSettings({
          darkUIMode: this.state.theme === "dark",
        });
      }
    );
    document.documentElement.setAttribute("data-theme", setTo);
    localStorage.setItem("theme", setTo);
  };

  toggleUserActions() {
    this.setState({
      visible: !this.state.visible,
    });
  }

  clearSession = () => {
    localStorage.clear();
    this.props.navigate("/");
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };

  render() {
    const user = localStorage.getItem("user");

    if (user == null) {
      const pathname = this.props.location.pathname;
      const onLoginPage = pathname.includes("/login");
      const onRegisterPage = pathname.includes("/register");

      return (
        <div className="main-navbar__auth">
          <a
            id="btn-login"
            href="/login"
            className="navbar-auth-btn navbar-auth-btn--login"
            aria-current={onLoginPage ? "page" : undefined}
          >
            Login
          </a>
          <Link
            id="btn-register"
            to="/"
            state={SCROLL_TO_PRICING_STATE}
            className="navbar-auth-btn navbar-auth-btn--register"
            aria-current={onRegisterPage ? "page" : undefined}
          >
            Register
          </Link>
        </div>
      );
    }

    const userData = JSON.parse(user);
    const avatarSrc =
      userData.avatar !== undefined
        ? userData.avatar.small
        : require("./../../../../images/avatars/0.jpg");
    const isDark = this.state.theme === "dark";

    return (
      <li className="navbar-user-menu" ref={this.wrapperRef}>
        <button
          type="button"
          className="navbar-user-menu__trigger"
          onClick={this.toggleUserActions}
          onMouseDown={(e) => e.preventDefault()}
          aria-expanded={this.state.visible}
          aria-haspopup="true"
          aria-label="Account menu"
        >
          <img
            className="navbar-user-menu__avatar"
            src={avatarSrc}
            alt=""
          />
          <span className="navbar-user-menu__name d-none d-md-inline-block">
            {userData.name}
          </span>
          <span className="navbar-user-menu__chevron d-none d-md-inline-block" aria-hidden="true">
            ▾
          </span>
        </button>

        <div
          className={`navbar-user-menu__panel${
            this.state.visible ? " is-open" : ""
          }`}
          role="menu"
        >
          <div className="navbar-user-menu__header">
            <img
              className="navbar-user-menu__header-avatar"
              src={avatarSrc}
              alt=""
            />
            <div className="navbar-user-menu__header-text">
              <span className="navbar-user-menu__header-name">
                {userData.name}
              </span>
              <span className="navbar-user-menu__header-email">
                {userData.email}
              </span>
            </div>
          </div>

          <Link
            className="navbar-user-menu__item"
            to="/user-profile"
            onClick={this.closeDropdown}
            role="menuitem"
          >
            <span className="navbar-user-menu__icon" aria-hidden="true">
              <i className="material-icons">person</i>
            </span>
            Profile
          </Link>

          <button
            type="button"
            className="navbar-user-menu__item navbar-user-menu__item--danger"
            onClick={() => {
              this.closeDropdown();
              this.clearSession();
            }}
            role="menuitem"
          >
            <span
              className="navbar-user-menu__icon navbar-user-menu__icon--danger"
              aria-hidden="true"
            >
              <i className="material-icons">logout</i>
            </span>
            Logout
          </button>

          <div className="navbar-user-menu__divider" />

          <div className="navbar-user-menu__footer">
            <span className="navbar-user-menu__footer-label">Dark mode</span>
            <button
              type="button"
              className="navbar-user-menu__toggle"
              role="switch"
              aria-checked={isDark}
              aria-label="Toggle dark mode"
              onClick={this.switchTheme}
            />
          </div>
        </div>
      </li>
    );
  }
}

export default withRouter(UserActions);
